import { createContext } from 'react';

import {
  BillingRate,
  BillingRatesReport,
} from '@totem/components/billingRates/dataTypes';
import { ReportInput } from '@totem/components/billingRates/parameterTypes';

interface Context {
  input: ReportInput;
  setInput: (input: ReportInput) => void;
  onAction?: (action: string, actionItem: BillingRate) => void;
  loading: boolean;
  reportData: BillingRatesReport;
  totalRecords: number;
}

export default createContext<Context>({
  input: {},
  setInput: () => {},
  onAction: () => {},
  loading: false,
  reportData: null,
  totalRecords: 0,
});
